export const shellyConfig = {
  common: {
    saving: "Salvataggio...",
    online: "Online",
    offline: "Offline",
  },

  step1: {
    title: "Configurazione Shelly",
    subtitle:
      "Collega il tuo account Shelly Cloud per controllare i tuoi relè (serrature elettriche, cancelli, ecc.).",
    connected: "Account collegato",
    notConnected: "Non collegato",
    credentialsInfo:
      "Trovi le tue credenziali nell'app Shelly: <b>Impostazioni utente → Chiave di autorizzazione Cloud</b>. Lì vedrai il <b>Server URI</b> e potrai generare la tua <b>Auth Key</b>.",
    serverUriPlaceholder: "es. shelly-103-eu.shelly.cloud",
    serverUriHelp: "Server Cloud assegnato al tuo account Shelly.",
    authKeyPlaceholderSaved: "•••••••• (già salvata, facoltativo modificarla)",
    authKeyPlaceholderNew: "Incolla la tua chiave di autorizzazione cloud",
    authKeyHelpSaved: "Puoi lasciarla vuota se hai già una chiave salvata.",
    authKeyHelpNew:
      "Questa chiave ti permette di controllare i tuoi dispositivi: conservala al sicuro.",
    testing: "Test in corso...",
    testConnection: "Testa la connessione",
    saveCredentials: "Salva credenziali",
  },

  step2: {
    title: "Selettore dispositivi per questa struttura",
    subtitle:
      "Seleziona solo i relè Shelly che riguardano <b>questa struttura</b>. Poi, nel PMS vedrai solo quelli selezionati.",
    selectedCount: "{count} selezionati",
    hintCredentials:
      "Inserisci il tuo Server URI e la Auth Key e clicca su <b>Testa la connessione</b> per caricare i tuoi dispositivi.",
    noDevices: "Nessun dispositivo trovato nel tuo account Shelly.",
    selectPlaceholder: "Seleziona dispositivi…",
    devicesSelected: "{count} dispositivo/i selezionato/i",
    noneSelected: "Nessun dispositivo selezionato",
    channels: "{count} canali",
    saveDevices: "Salva i dispositivi per questa struttura",
  },

  step3: {
    title: "Controllo e assegnazione (PMS)",
    subtitle:
      "Assegna ogni relè a <b>Porta principale</b>, <b>Unità</b> o <b>Cancello</b> e imposta l'impulso di apertura.",
    assignedCount: "{count} assegnati",
    noSavedDevices:
      "Non hai ancora dispositivi salvati per questa struttura. Usa il <b>Selettore</b> qui sopra e poi salva.",
    pulseInfo:
      "<b>Apri</b> invia un impulso al relè (si accende e si spegne da solo dopo i secondi configurati): ideale per serrature elettriche e cancelli. Shelly non genera codici PIN.",
    open: "Apri",
    openTooltip: "Apri (impulso)",
    turnOnTooltip: "Accendi il relè",
    turnOffTooltip: "Spegni il relè",
    refreshTooltip: "Aggiorna stato",
    assignment: "Assegnazione",
    assignNone: "Non assegnato",
    assignCommon: "Porta principale (condivisa)",
    assignUnit: "Porta dell'appartamento",
    assignGate: "Cancello / Garage",
    hintNone: "Non verrà controllato dal PMS.",
    hintAssigned: "Sarà collegato a questa struttura per l'apertura da remoto.",
    unitLabel: "Unità / Alloggio",
    selectUnit: "Seleziona un'unità",
    unitFallback: "Unità {id}",
    selectUnitHint: "Scegli quale unità apre questo relè.",
    channelLabel: "Canale del relè",
    channelOption: "Canale {n}",
    channelHint: "Canale collegato alla serratura (dispositivi multi-relè).",
    pulseLabel: "Impulso di apertura (secondi)",
    pulseHint: "Per quanto tempo il relè resta acceso durante l'apertura.",
    nameLabel: "Nome (facoltativo)",
    namePlaceholder: "es. Porta principale / Apt 101",
    nameHint: "Nome mostrato nel PMS per questo dispositivo.",
    saveAssignment: "Salva assegnazione",
    tip:
      "Suggerimento: assegna ogni relè e clicca su <b>Salva assegnazione</b>. I pulsanti di controllo si attivano una volta assegnato il dispositivo.",
  },

  toast: {
    loadDevicesFailed: "Impossibile caricare i dispositivi",
    loadDevicesError: "Errore durante il caricamento dei dispositivi",
    missingCredentials: "Devi inserire il Server URI e la tua Auth Key Shelly.",
    connectionSuccess:
      "Connessione riuscita. {count} dispositivo/i trovato/i.",
    testError: "Errore durante il test della connessione",
    invalidAuthKey: "Devi inserire una Auth Key valida (almeno 10 caratteri).",
    missingServerUri: "Devi inserire il Server URI del tuo account Shelly.",
    credentialsSaved: "Credenziali salvate con successo",
    credentialsError: "Errore durante il salvataggio delle credenziali",
    credentialsSaveError: "Errore durante il salvataggio delle credenziali: {error}",
    selectAtLeastOne:
      "Devi selezionare almeno un dispositivo per questa struttura.",
    devicesSaved: "Dispositivi salvati per questa struttura",
    devicesSaveFailed: "Impossibile salvare i dispositivi",
    saveError: "Errore durante il salvataggio: {error}",
    selectUnitForApartment:
      "Seleziona l'unità per i relè assegnati come 'Porta dell'appartamento'.",
    assignmentFailed: "Impossibile salvare l'assegnazione",
    assignmentSaved: "Assegnazione salvata con successo",
    assignmentSaveError: "Errore durante il salvataggio dell'assegnazione: {error}",
    opOpen: "Apertura inviata (impulso relè)",
    opOn: "Relè acceso",
    opOff: "Relè spento",
    opDone: "Azione completata",
    opFailed: "Impossibile completare l'azione",
    opError: "Errore durante l'esecuzione dell'azione",
  },
};
